import React, {useCallback, useState} from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import Task from "../../../../../../model2/task/task"
import Event from "../../../../../../model2/event/event"
import Project from "../../../../../../model2/project/project"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../gd-components/buttons/control-button/control-button-standard"
import EntityCollection from "../../../../../../model2/entities-collection/entities-collection"
import {isBulkSelection} from "../../../../../../gd/right-click-menu";

const debug = false
// const debug = "FieldDependencies_TableCell"

export default function FieldDependencies_TableCell(props: FieldTableCellProps) {

    const [isHovered, setIsHovered] = useState(false)
    const canEdit = !props.manager.isReadOnly && props.field.canEdit(props.listItem.item)

    const onMouseEnter = () => {
        if (!canEdit) return

        setIsHovered(true)
    }

    const onMouseLeave = () => {
        setIsHovered(false)
    }

    const onClick = useCallback((e: React.MouseEvent, entity: Task | Event | Project) => {
        debug && console.log(debug, 'onClick', entity.constructor, entity)
        if (isBulkSelection(e)) return
        if (!canEdit) return

        e.stopPropagation()
        switch (entity.constructor) {
            case Task:
                gd.taskView.open(entity.id)
                break

            case Event:
                gd.openEvent(entity.id)
                break

            case Project:
                gd.navigation.goToProject(entity.id)
        }
    }, [props.listItem])

    const onClickAdd = useCallback((e: React.MouseEvent)=>{
        if (isBulkSelection(e)) return
        if (canEdit && props.field.fieldParams.tableCellOnAdd) {
            props.field.fieldParams.tableCellOnAdd(props.listItem)
        }
    }, [canEdit])

    const style         = getTableCellStyle(props)
    const itemsToShow   = Math.floor((style.width - 30) / 70) || 1

    const collection    = _.get(props.listItem.item, props.field.fieldId) as EntityCollection
    const items         = collection.models || []
    const shownItems    = _.slice(items, 0 , itemsToShow)
    const hiddenItems   = _.slice(items, itemsToShow, items.length)

    debug && console.log(debug, 'render', isHovered, shownItems)

    if (!isHovered) {
        return (
            <div className      = "cell-flex ui5-field-editable size-small flex-row-left-center"
                 style          = {style}
                 onMouseEnter   = {onMouseEnter}
                 onMouseLeave   = {onMouseLeave}>
                    {_.map(shownItems, (entity: any, key: number) => (
                        <div key        = {key}
                             className  = "ui5-property short-id-label m-r-5 txt-truncate"
                             onClick    = {(e: React.MouseEvent) => {onClick(e, entity)}}>
                            #{entity.shortId || entity.rid}
                        </div>
                    ))}
                    {!_.isEmpty(hiddenItems) && <div className="ui5-counter dark">+{hiddenItems.length}</div>}
            </div>
        )
    }

    return(
        <div className="cell-flex is-hovered" style={style} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClickAdd}>
            <div className="ui5-field-editable size-small is-hovered flex-row-between-center w-100-percent h-100-percent">
                <div className="flex-row-left-center txt-truncate">
                    {_.map(shownItems, (entity: any, key: number) => (
                        <div key        = {key}
                             className  = "ui5-property short-id-label m-r-5 txt-truncate"
                             onClick    = {(e: React.MouseEvent) => {onClick(e, entity)}}>
                            #{entity.shortId || entity.rid}
                        </div>
                    ))}
                    {!_.isEmpty(hiddenItems) && <div className="ui5-counter dark">+{hiddenItems.length}</div>}
                </div>

                <div className="buttons">
                    <ControlButtonStandard className    = "btn-add"
                                           type         = {ControlButtonType.PLUS}
                                           hint         = "Add time report"
                                           onClick      = {onClickAdd}
                                           size         = {24}/>
                </div>
            </div>
        </div>
    )
}


